import "./index.scss";

export const EmailSubscriptionFeedback = ({
  message,
  onDismiss,
  isErrorFeedback
}) => {
  return isErrorFeedback ? (
    <div className="notification error">
      <div className="long-notification">
        <strong>ERROR!</strong>
        <span>{message}</span>
      </div>
      <button className="dismiss" onClick={onDismiss} type="button">
        <svg className="close-svg" viewBox="0 0 40 40">
          <path d="M 10,10 L 30,30 M 30,10 L 10,30" />
        </svg>
      </button>
    </div>
  ) : (
    <div className="notification success">
      <div className="long-notification">
        <strong>SUCCESS!</strong>
        <span>{message}</span>
      </div>
    </div>
  );
};
